/* eslint-disable @typescript-eslint/camelcase */
import {
  HangingIncomingSummary,
  HangingIncomingFilterRequest,
  FilterRiwayatRequest,
  RiwayatHangingLasmileRequest,
  HangingIncoming,
  HistoryFollowUpIncomingRequest,
  HangingLastMileFilterRequest,
  HistoryHangingIncomingFilterRequest,
  HistoryHangingIncomingEntities,
  HistoryHanging
} from "@/domain/entities/HangingIncoming";
import { Action, getModule, Module, VuexModule } from "vuex-module-decorators";
import { SttHangingPresenter } from "../presenters/SttHangingPresenter";
import { container } from "tsyringe";
import store from "@/store";
import { HangingComponent } from "@/app/infrastructures/dependencies/modules/HangingComponent";
import { MainAppController } from "./MainAppController";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import {
  FAILED_ERROR,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import {
  SubmitHangingConfirmationFollowUpInterface,
  SubmitHangingConfirmationUpdateStatusInterface
} from "@/data/payload/contracts/HangingRequest";
import {
  HangingConfirmDonePosBkdPayload,
  HangingLastMileConfirmApiRequest,
  SubmitHangingConfirmationFollowUp,
  SubmitHangingConfirmationUpdateStatus
} from "@/data/payload/api/HangingApiRequest";
import { HistoryFollowUpLastMileRequest } from "@/domain/entities/HangingLastMile";
import { HangingLastMile } from "@/domain/entities/HangingLastMile";
import {
  HistoryFollowUpOutgoingFilterRequest,
  HistoryFollowUpOutgoingEntities,
  HangingOutgoingRequest,
  ConfirmHangingOutgoingRequest,
  DownloadHangingOutgoing,
  HangingBookingPosSummary
} from "@/domain/entities/HangingOutgoing";
import {
  HistoryHangingBookingFilterRequest,
  HistoryHangingBookingEntities,
  HistoryFollowUpBookingFilterRequest,
  HistoryFollowUpBookingEntities
} from "@/domain/entities/HangingBooking";
import {
  HangingList,
  HangingPosBkdListRequest
} from "@/domain/entities/Hanging";
import { HangingConsoleBkdListRequest, ConfirmHangingBkdConsole, DownloadHangingBkdConsole, HangingBkdSummaryConsole } from '@/domain/entities/HangingBkd';

HangingComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "stt-hanging-incoming"
})
class SttHangingStore extends VuexModule {
  @Action
  async getHangingIncomingSummary() {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingIncomingSummary();
  }

  @Action
  async getHangingLastMileSummary() {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingLastMileSummary();
  }

  @Action
  public getHangingIncoming(
    params: HangingIncomingFilterRequest
  ): Promise<HangingIncoming[]> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingIncoming(params);
  }

  @Action
  public getHangingLastMile(
    params: HangingLastMileFilterRequest
  ): Promise<HangingLastMile[]> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingLastMile(params);
  }

  @Action
  public getFilterRiwayat(
    params: FilterRiwayatRequest
  ): Promise<HangingIncomingSummary> {
    const presenter = container.resolve(SttHangingPresenter);
    MainAppController.showLoading();

    return new Promise((resolve, reject) => {
      presenter
        .getFilterRiwayat(params)
        .then((res: HangingIncomingSummary) => {
          return res;
        })
        .catch((err: any) => {
          const message = err.response?.data?.message;
          const code = err.response?.data?.code;

          if (code !== 400) {
            MainAppController.showErrorMessage(
              typeof message === "string"
                ? new ErrorMessageEntities({
                    message: message,
                    title: "Server Error",
                    type: FAILED_ERROR
                  })
                : parsingErrorResponse(err, "Error")
            );
          }
          reject(err);
        })
        .finally(() => {
          MainAppController.closeLoading();
        });
    });
  }

  @Action
  async submitHangingConfirmationFollowUp(
    payload: SubmitHangingConfirmationFollowUp
  ) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.submitHangingConfirmationFollowUp(payload);
  }

  @Action
  async confirmDoneHangingPosBkd(payload: HangingConfirmDonePosBkdPayload) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.confirmDoneHangingPosBkd(payload);
  }

  @Action
  async hangingLastMileConfirmFollowUp(
    payload: HangingLastMileConfirmApiRequest
  ) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.hangingLastMileConfirmFollowUp(payload);
  }

  @Action
  async submitHangingConfirmationUpdateStatus(
    payload: SubmitHangingConfirmationUpdateStatus
  ) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.submitHangingConfirmationUpdateStatus(payload);
  }

  @Action
  public getRiwayatHangingLastmile(params: RiwayatHangingLasmileRequest) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getRiwayatHangingLastmile(params);
  }

  @Action
  async downloadHangingIncoming(listStt: []) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.downloadHangingIncoming(listStt);
  }

  @Action
  async downloadHangingLastMile(listStt: []) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.downloadHangingLasMile(listStt);
  }

  @Action
  public getHistoryFollowUpIncoming(params: HistoryFollowUpIncomingRequest) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHistoryFollowUpIncoming(params);
  }

  @Action
  public getHistoryFollowUpLastMile(params: HistoryFollowUpLastMileRequest) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHistoryFollowUpLastMile(params);
  }

  @Action
  public getHistoryHangingIncoming(
    params: HistoryHangingIncomingFilterRequest
  ): Promise<HistoryHangingIncomingEntities> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHistoryHangingIncoming(params);
  }

  @Action
  public getHistoryHangingOutgoing(
    params: HistoryHangingIncomingFilterRequest
  ): Promise<HistoryHanging> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHistoryHangingOutgoing(params);
  }

  @Action
  public getHangingOutgoingSummary() {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingOutgoingSummary();
  }

  @Action
  public getHistoryFollowUpOutgoing(
    params: HistoryFollowUpOutgoingFilterRequest
  ): Promise<HistoryFollowUpOutgoingEntities> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHistoryFollowUpOutgoing(params);
  }

  @Action
  public getHangingOutgoing(params: HangingOutgoingRequest) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingOutgoing(params);
  }

  @Action
  public confirmHangingOutgoing(payload: ConfirmHangingOutgoingRequest) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.confirmHangingOutgoing(payload);
  }

  @Action
  public downloadHangingOutgoing(payload: DownloadHangingOutgoing) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.downloadHangingOutgoing(payload);
  }

  @Action
  public getHistoryHangingBooking(
    params: HistoryHangingBookingFilterRequest
  ): Promise<HistoryHangingBookingEntities> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHistoryHangingBooking(params);
  }

  @Action
  public getHangingBookingPosSummary(): Promise<HangingBookingPosSummary> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingBookingPosSummary();
  }

  @Action
  public getHistoryFollowUpBooking(
    params: HistoryFollowUpBookingFilterRequest
  ): Promise<HistoryFollowUpBookingEntities> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHistoryFollowUpBooking(params);
  }

  @Action
  public getHangingPosBkd(
    params: HangingPosBkdListRequest
  ): Promise<HangingList[]> {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingPosBkd(params);
  }

  @Action
  async donwloadHangingPosBkd(listStt: []) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.donwloadHangingPosBkd(listStt);
  }

  @Action
  async getHangingConsoleBkdSummary() {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingConsoleBkdSummary();
  }

  @Action
  public getHangingConsoleBkdList(params: HangingConsoleBkdListRequest) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.getHangingConsoleBkdList(params);
  }

  @Action
  public confirmHangingBkdConsole(payload: ConfirmHangingBkdConsole) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.confirmHangingBkdConsole(payload);
  }

  @Action
  public downloadHangingBkdConsole(payload: DownloadHangingBkdConsole) {
    const presenter = container.resolve(SttHangingPresenter);
    return presenter.downloadHangingBkdConsole(payload);
  }
}
export const SttHangingController = getModule(SttHangingStore);